import { ReceiptJapaneseYen } from 'lucide-react';
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useVisualViewportHeight } from './hook.js';

export const CommerceDisclosure = () => {
    const vvHeight = useVisualViewportHeight();
    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);

    const commerceDisclosureList = [
        {
            header: "1. 法人名",
            text: "aome合同会社",
        },
        {
            header: "2. 所在地",
            text: "東京都豊島区池袋二丁目11番9号",
        },
        {
            header: "3. 電話番号",
            text: "050-1740-8232",
            additionalInfo: "※お問い合わせは原則としてメールにてお願いいたします。"
        },
        {
            header: "4. メールアドレス",
            text: "hello@aome.co.jp",
        },
        {
            header: "5. 職務執行者",
            text: "バーンズ　ライリー　グレイソン",
        },
        {
            header: "6. 商品代金以外の必要料金",
            text: "本サービスの利用に必要なインターネット接続料は、利用者の負担となります。",
        },
        {
            header: "7. 返品・キャンセルについて",
            text: "サービスの性質上、提供開始後の返品・キャンセルはお受けできません。ただし、法令に基づき返金義務が生じる場合はこの限りではありません。",
        },
        {
            header: "8. 引渡時期",
            text: "登録完了後、すぐに本サービスをご利用いただけます。14日間の無料トライアル期間中も、すべての機能をご利用いただけます。",
        },
        {
            header: "9. 支払方法",
            text: "クレジットカード、Apple Pay、Google Pay、Link（いずれもStripe社の決済システムを利用）",
        },
        {
            header: "10. 支払時期",
            text: "無料トライアル期間終了後に決済が行われ、その後は契約更新日に自動的に決済されます。無料トライアル期間中に解約された場合、料金は発生しません。",
        },
        {
            header: "11. 販売価格",
            text: "本サービスは定額制の有料サービスです。料金はウェブサイトに表示され、表示価格は消費税込みです。",
        },
        {
            header: "12.  解約について",
            text: "設定画面からいつでも解約できます。解約後も、お支払い済みの期間が終了するまでご利用いただけます。",
        }

    ]

    return (
        <div
            className="w-full h-auto lg:h-full flex flex-col gap-8 p-2 lg:p-4 lg:pb-6"
            style={{ maxHeight: isDesktop ? '80vh' : Math.round(vvHeight * 0.8) }}
        >

            <div className="flex gap-2 items-center">
                <span className="">
                    <ReceiptJapaneseYen className='text-base-text size-6' strokeWidth={1} />
                </span>
                <h1 className="text-base-text font-light text-lg w-max">
                    特定商取引法に基づく表記
                </h1>
            </div>


            <div className="flex flex-col py-4 gap-6 h-full overflow-y-auto pr-2">
                {commerceDisclosureList.map((commerceDisclosure, index) => {
                    return (
                        <div className="flex flex-col gap-2" key={index}>
                            <p className="text-base-text font-normal">{commerceDisclosure.header}</p>
                            <div className="text-base-text font-light">{commerceDisclosure.text}
                                {commerceDisclosure.additionalInfo &&
                                    <p className="text-base-text font-light">{commerceDisclosure.additionalInfo}</p>
                                }
                            </div>
                            {commerceDisclosure.points &&
                                <ul className="list-disc pl-8">
                                    {commerceDisclosure.points.map((point, index) => {
                                        return (
                                            <li className="text-base-text font-light" key={index}>{point}</li>
                                        )
                                    })}
                                </ul>
                            }

                        </div>
                    )
                })}
            </div>
        </div>
    )
}